import { StyledAddMemberPopup } from 'pages/CommunityOverallScheduler/CreateEventGroupPopup/styled';
import styled from 'styled-components';

export const SubscriptionPopupCard = styled(
  StyledAddMemberPopup.CardWrapper.Card,
)`
  align-items: flex-start;

  ${StyledAddMemberPopup.CardWrapper.Card.Header} {
    align-items: flex-start;
    align-self: stretch;
    max-width: 480px;
    width: 100%;
  }

  ${StyledAddMemberPopup.CardWrapper.Card.title} {
    text-align: left !important;
  }

  ${StyledAddMemberPopup.CardWrapper.Card.subTitle} {
    text-align: left !important;
  }
`;
